import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddDiscountLayer from "../../components/ManageDiscount/DiscountFormPage";

const DiscountUpdate = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
          <Breadcrumb  id="title" title2="Discount Management" link2="/discount" title="Update Discount" />
  

        <AddDiscountLayer />
      </MasterLayout>
    </>
  );
};

export default DiscountUpdate;
